import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ca-information-item',
    templateUrl: './information-item.component.html',
    styleUrls: ['./information-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformationItemComponent {
    @Input() label: string;
    @Input() information: string;
}
